import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Grid, Container, Typography, Tab, Tabs, Icon } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import BlockIcon from '@material-ui/icons/Block';
import { capitalCase } from 'change-case';
import { ComponentsLib } from '@payface-frontends-libs/components';
const { SimpleGrid, Page } = ComponentsLib.Generics;
export function GeneralAnalytics() {
    const [currentTab, setCurrentTab] = useState('Pendentes');
    const TABLE_HEAD = [
        { id: 'name', label: 'Name', alignRight: false },
        { id: 'company', label: 'Company', alignRight: false },
        { id: 'role', label: 'Role', alignRight: false },
        { id: 'isVerified', label: 'Verified', alignRight: false },
        { id: 'status', label: 'Status', alignRight: false },
        { id: '' },
    ];
    const ACCOUNT_TABS = [
        {
            value: 'Pendentes',
            icon: _jsx(Icon, { component: WarningIcon, fontSize: "small" }, void 0),
            component: _jsx(SimpleGrid, { dataList: [], tableHead: TABLE_HEAD }, void 0),
        },
        {
            value: 'Aprovados',
            icon: _jsx(Icon, { component: CheckCircleIcon, fontSize: "small" }, void 0),
            component: _jsx("div", { children: "Billing" }, void 0),
        },
        {
            value: 'Reprovados',
            icon: _jsx(Icon, { component: BlockIcon, fontSize: "small" }, void 0),
            component: _jsx("div", { children: "notifications" }, void 0),
        },
    ];
    return (_jsx(Page, Object.assign({ title: "Dashboard: Analytics | Minimal-UI" }, { children: _jsxs(Container, Object.assign({ maxWidth: "xl" }, { children: [_jsx(Box, Object.assign({ sx: { pb: 5 } }, { children: _jsx(Typography, Object.assign({ variant: "h4" }, { children: "Mesa de An\u00E1lise" }), void 0) }), void 0), _jsx(Grid, Object.assign({ container: true, spacing: 3 }, { children: _jsxs(Container, { children: [_jsx(Tabs, Object.assign({ value: currentTab, scrollButtons: "auto", variant: "scrollable", allowScrollButtonsMobile: true, onChange: (_e, value) => setCurrentTab(value) }, { children: ACCOUNT_TABS.map((tab) => (_jsx(Tab, { label: capitalCase(tab.value), icon: tab.icon, value: tab.value }, tab.value))) }), void 0), _jsx(Box, { sx: { mb: 5 } }, void 0), ACCOUNT_TABS.map((tab) => {
                                const isMatched = tab.value === currentTab;
                                return isMatched && _jsx(Box, { children: tab.component }, tab.value);
                            })] }, void 0) }), void 0)] }), void 0) }), void 0));
}
//# sourceMappingURL=GeneralAnalytics.js.map